// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-subscription-contract-request-schema',
  type: 'object',
  required: ['subscriptionType', 'userId'],
  properties: {
    subscriptionType: {
      enum: [
        1,
        2,
      ],
    },
    userId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
